(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery-24h-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-24h-badge')) {
    customElements.define('delivery-24h-badge', class extends HTMLElement {
      connectedCallback() {
        const variantData = this.querySelector('[data-delivery-24h-variants]');
        if (!variantData) return;

        this.variantStock = JSON.parse(variantData.textContent);
        this.productSection = this.closest('[data-section-type="product"]');
        this.updateVisibility = (visible) => {
          this.hidden = !visible;
          const deliveryProperty = this.querySelector('[data-delivery-24h-property]');
          if (deliveryProperty) deliveryProperty.disabled = this.hidden;
        };
        this.updateVisibility(!this.hidden);
        this.onVariantChanged = (event) => {
          if (event.target.closest('[data-section-type="product"]') !== this.productSection) return;

          const variant = event.detail.variant;
          if (!variant) {
            this.updateVisibility(false);
            return;
          }

          if (!Object.prototype.hasOwnProperty.call(this.variantStock, variant.id)) return;
          this.updateVisibility(this.dataset.eligible === 'true' && (this.dataset.override === 'true' || this.variantStock[variant.id] === true));
        };

        this.productSection?.addEventListener('variant:changed', this.onVariantChanged);
      }

      disconnectedCallback() {
        this.productSection?.removeEventListener('variant:changed', this.onVariantChanged);
        this.productSection = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
